module.exports = __webpack_public_path__ + "img/alv-logo.52551fb0.png";